import { render, staticRenderFns } from "./HighlightsTab.vue?vue&type=template&id=f71fdf2e"
import script from "./HighlightsTab.vue?vue&type=script&lang=js"
export * from "./HighlightsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports